/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HeadingInputs */

const fr_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Search`)
};

const en_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Search`)
};

/**
* | output |
* | --- |
* | "Quick Search" |
*
* @param {HeadingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heading = /** @type {((inputs?: HeadingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HeadingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_heading(inputs)
	return en_heading(inputs)
});